import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import InsetWrapper from '@s/InsetWrapper';
import { TranslationContext } from "@c/Translations";
import Translation from '../../../../shared/Translation';
import { useSelector } from 'react-redux';
import { getIsEmailFieldDisabled } from '../../../selectors/reservation';
import { getConfigClient } from '@showclix-shared-util/configClient';
import clsx from 'clsx';

const Email = props => {
    const isEmailFieldDisabled = useSelector(getIsEmailFieldDisabled);

    const translationContext  = useContext(TranslationContext);

    const onFocus = e => {
        if(props.onFocus) {
            props.onFocus(e, translationContext.t('checkout__email_address'));
        }
    }

    return (
        <InsetWrapper hasError={!!props.error?.message}>
            <div className="input__top">
              <label
                className="input__label"
                id="memberEmailLabel"
                htmlFor="memberEmail"
              >
                {translationContext.t("checkout__email_address")}
              </label>
            </div>
            <input
                id="memberEmail"
                name="memberEmail"
                type="email"
                className="input__control"
                spellCheck="false"
                placeholder={translationContext.t("checkout__email_address")}
                value={props.email}
                onChange={props.onEmailChange}
                required={props.required ? true : false}
                onFocus={onFocus}
                onBlur={props.onBlur}
                disabled={isEmailFieldDisabled}
                autoComplete='email'
                aria-invalid={!!props.error?.message}
                aria-describedby='memberEmail-error'
            />
            <p
              id={`memberEmail-error`}
              className={clsx("input--error__text", {
                "input--error__text--hidden": !props.error?.message
              })}
              role="alert"
              aria-live="assertive"
              aria-describedby="memberEmailLabel"
            >
                {!!props.error?.message && (
                  <Translation interpolation={props.error?.interpolation}>
                      {props.error.message}
                  </Translation>
                )}
            </p>
        </InsetWrapper>
    );
}

Email.propTypes = {
    email: PropTypes.string.isRequired,
    onEmailChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
}

export default Email;
